export default __webpack_public_path__ + "static/media/no-image-placeholder.08eb1783.png";